module.exports = __webpack_public_path__ + "static/media/md.8f2e0071.svg";